<template>
    <b-field
            :label="label"
            :type="error? 'is-danger': ''"
            :message="error">
        <b-field>
            <b-switch
                    @input="val => $emit('input', val)"
                    :size="size"
                    :type="color"
                    :name="name"
                    :false-value="falseValue"
                    :true-value="trueValue"
                    :value="value">
                {{ holder }}
            </b-switch>
        </b-field>
    </b-field>
</template>

<script>
    export default {
        name: "FormSwitch",
        props: {
            value: {},
            error: {},
            label: String,
            holder: String,
            name: String,
            trueValue: {
                default: true
            },
            falseValue: {
                default: false
            },
            size: String,
            color: String,
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>